import React from 'react';
import { formatNumberShort } from 'shared/utils/format-number-short';

import * as Styled from './value-badge.style';

export type ValueBadgeProps = {
  value: number;
  // Consumers offset the badge against their own anchor via `styled(ValueBadge)`.
  className?: string;
};

export const ValueBadge: React.FC<ValueBadgeProps> = ({ value, className }) => (
  <Styled.Badge className={className}>{formatNumberShort(value)}</Styled.Badge>
);
